export const recentListTypes = {
  comms: "Comms",
  updates: "Updates",
};
